<router-outlet></router-outlet>
<page-loader *ngIf="isLoading"></page-loader>
